import cookieHandler from '../utils/_cookieHandler';
import { getCurrentPageClass } from '../utils/_pageClass';
import { createMediaQueryList } from '../utils/_breakpoints';

const COOKIE_NAME = 'kz_lastsessionupdate';
const PAGE_BLACKLIST = ['checkout-customer', 'checkout-cart'];

class oMinicartCookie extends HTMLDivElement {
    constructor() {
        super();
        this.minicart = document.getElementById('o-sidebar-miniCart');
        this.mqlDesktop = createMediaQueryList('md');

        // Check if user is Desktop and launch the script if true
        if (this.mqlDesktop.matches) {
            // Wait for page load before checking
            if (document.readyState === 'complete') {
                this.checkReturningCustomer();
            } else {
                window.addEventListener('load', this.checkReturningCustomer.bind(this));
            }
        }
    }

    updateSessionCookie() {
        cookieHandler.createMin(
            COOKIE_NAME,
            (new Date()).toISOString(),
            (('reopeningDelay' in this.dataset) && parseFloat(this.dataset.reopeningDelay)) || 0,
        );
    }

    reopenMinicart() {
        // Prepare close event
        const onClose = (event) => {
            if (event.detail.sidebar !== this.minicart) return;
            this.minicart.classList.remove('returning-customer');
            document.removeEventListener('oSidebar:close', onClose);
        };
        document.addEventListener('oSidebar:close', onClose);

        this.minicart.classList.add('returning-customer');
        // Open minicart
        document.dispatchEvent(
            new CustomEvent(
                'oSidebarAjax:prepareAndSendEvent',
                { detail: { sidebarId: 'o-sidebar-miniCart' } },
            ),
        );
    }

    checkReturningCustomer() {
        // TODO: use a better way to find if the cart is empty (need rework on oNavigation)
        if (
            !PAGE_BLACKLIST.includes(getCurrentPageClass()) // page is allowed
            && !cookieHandler.read(COOKIE_NAME) // cookie/session has expired
            && document.querySelectorAll('.mini-cart.active').length !== 0 // cart is not empty
        ) {
            this.reopenMinicart();
        }
        this.updateSessionCookie();
    }
}

customElements.define('o-minicart-cookie', oMinicartCookie, {
    extends: 'div',
});
